import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function BodyStyleColorTypeChips() {
  const {catalogueApi} = useVehicleFormContext();
  return (
    <Field
      type="chips"
      name="exteriorColorSpecification"
      options={catalogueApi?.bodyColorTypeOptions ?? []}
      label={i18n.t('entity.vehicle.labels.bodyColorType')}
      isDeselectable
    />
  );
}
